<p-tabs value="0">
    <p-tablist>
        <p-tab value="0" class="text-xs py-2 px-4">Reporte seguimiento</p-tab>
        <p-tab value="1" class="text-xs py-2 px-4">Seguimiento de cliente</p-tab>
        <p-tab value="2" class="text-xs py-2 px-4">Comparativo performance vs budget</p-tab>
        <p-tab value="3" class="text-xs py-2 px-4">Reporte Contratos</p-tab>
        <p-tab value="4" class="text-xs py-2 px-4">Reporte Comparativo Cierre Anual</p-tab>
    </p-tablist>
    <p-tabpanels>
        <p-tabpanel value="0">
            <app-reporte-seguimiento></app-reporte-seguimiento>
        </p-tabpanel>
        <p-tabpanel value="1">
            <app-reporte-seguimiento-cliente></app-reporte-seguimiento-cliente>
        </p-tabpanel>
        <p-tabpanel value="2">
            <app-reporte-performance-budget></app-reporte-performance-budget>
        </p-tabpanel>
        <p-tabpanel value="3">
            <app-reporte-contratos></app-reporte-contratos>
        </p-tabpanel>
        <p-tabpanel value="4">
            <app-reporte-cierre-anual></app-reporte-cierre-anual>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>